import React from "react";
import { Link } from "react-router-dom";

const colors = ["#0088FE", "#00C49F", "#FFBB28"];
const delay = 4500;


const items = [
    {
        "element": <img className={'imgco56'} src={'./banner/1.png'}/>
    },

    {
        "element": <img className={'imgco56'} src={'./banner/2.png'}/>
    },

    {
        "element": <img className={'imgco56'} src={'./banner/3.png'}/>
    },

    {
        "element": <img className={'imgco56'} src={'./banner/4.png'}/>
    },
    
   
]

export default function MySliderShow() {
  const [index, setIndex] = React.useState(0);
  const timeoutRef = React.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  React.useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === items.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index]);





  function handleNext(){

    let next = index + 1 < items.length ? index + 1 : 0
    setIndex(next)
  }




  function handlePrev(){

    let prev = index - 1 < 0 ? 4 - 1 : index - 1;
      setIndex(prev)
  
  }

  return (
    <div className="slideshow56 slideshow561">

      <div
        className="slideshowSlider56"
        style={{ transform: `translate3d(${index * 100}%, 0, 0)` }}
      >
        {items.map((item, index) => (
          <Link to={'/prize-exchange'}>

          <div
            className="slide56"
            key={index}
          >
              {item.element}
          </div>
          </Link>
        ))}
      </div>






      <div className="slideshowDots56 slideshow2024">
  {items.map((_, idx) => (
    <div
      key={idx}
      className={`slideshowDot561${index === idx ? " active" : ""}`}
      onClick={() => {
        setIndex(idx);
      }}
    ></div>
  ))}
</div>








    </div>
  );
}

